import {
  Box,
  CircularProgress,
  Grid,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
// import RootComponents from "../../components/common/RootComponents";
import styles from "./Profile.module.css";
import ProfileImage from "./ProfileImage";
// import profile_image from "../../assets/images/ajit_image.jpeg";
import {
  convertArrayToString,
  customTextColor,
  formatDate,
} from "../../utils/const";
import ActivityCard from "./ActivityCard";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  benchSalesProfileCardCount,
  getProfile,
} from "../../redux/profile/profileSlice";
import { useDispatch, useSelector } from "react-redux";
import { getPostRequirement } from "../../redux/post-requirement/postRequirementSlice";
import { getTrackerDetails } from "../../redux/internal-tracking/InternalTrackerSlice";
import { fetchMyCredit } from "../../redux/credit/creditSlice";
import { getSubmissionTracker } from "../../redux/internal-tracking/InternalSubmissionSlice";
import { allLocation } from "../../redux/common/locationSlice";
import CandidateListDrawer from "./CandidateListDrawer";
import TransForCreditDrawer from "../Dashboard/TransForCreditDrawer";
import AddCreditDrawer from "../Dashboard/AddCreditDrawer";
import ProfileViewDrawer from "./ProfileViewDrawer";
import RequirementPostDrawer from "../Requirement/RequirementPostDrawer";

const posting_list = [
  {
    value: "jobposting",
    label: "Job Posting",
  },
  {
    value: "consultantstracker",
    label: "Candidate Tracker",
  },

  {
    value: "requirementtracker",
    label: "Requirement Tracker",
  },
];

const posting_list1 = [
  {
    value: "jobapplied",
    label: "Job Applied",
  },
  {
    value: "jobaccepted",
    label: "Job Accepted",
  },

  {
    value: "requirementsubmission",
    label: "Requirement Tracker",
  },
];

const Profile = () => {
  const [activityType, setActivityType] = useState("jobposting");
  const [userDetails, setUserDetails] = useState("");
  const [profile_image, setProfile_image] = useState(null);
  const [banner, setBanner] = useState(null);
  const [internalTrack, setInternalTrack] = useState([]);
  const [showCandidateList, setShowCandidateList] = useState(false);
  const handleCloseShowCandidateList = () => setShowCandidateList(false);
  const handleShowCandidateList = () => setShowCandidateList(true);
  const profile = useSelector((state) => state.profile);
  const cardCountData = useSelector((state) => state.profile.cardCountData);
  const postRequirement = useSelector((state) => state.postrequirement.data);
  const loadingStatus = useSelector((state) => state.postrequirement.status);
  const locations = useSelector((state) => state.location) || [];

  const [showPostRequirement, setShowPostRequirement] = useState(false);
  const handleCloseShowPostRequirement = () => setShowPostRequirement(false);
  const handleShowPostRequirement = () => setShowPostRequirement(true);

  const trackDetails = useSelector((state) => state.tracker.data);
  const trackLoadingStatus = useSelector((state) => state.tracker.status);
  const myCredit = useSelector((state) => state.credit.creditDetails);
  const submisionTrackDetails = useSelector(
    (state) => state.trackersubmission.data
  );

  const [showAddCredit, setShowAddCredit] = useState(false);
  const handleCloseShowAddCredit = () => setShowAddCredit(false);
  const handleShowAddCredit = () => setShowAddCredit(true);

  const [showTransfor, setShowTransfor] = useState(false);
  const handleCloseShowTransfor = () => setShowTransfor(false);
  const handleShowTransfor = () => setShowTransfor(true);

  const [showViewProfile, setShowViewProfile] = useState(false);
  const handleCloseShowViewProfile = () => setShowViewProfile(false);
  const handleShowViewProfile = () => setShowViewProfile(true);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(allLocation());
  }, []);

  const getLocationById = (id) => {
    let locationResult = locations?.data?.locations?.find(
      (res) => res.id === id
    );
    return locationResult?.name;
  };

  const getPreferLocationNames = (preferLocation) => {
    return preferLocation
      ?.map(
        (id) =>
          locations?.data?.locations?.find((location) => location.id === id)
            ?.name
      ) // Map IDs to names
      ?.filter(Boolean) // Remove any undefined values if IDs don't match
      ?.join(", "); // Join names with a comma and space
  };

  const getFormattedDate = (date) => {
    const day = String(date.getDate()).padStart(2, "0"); // Ensure two digits
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Ensure two digits
    const year = String(date.getFullYear()); // Get last two digits of the year
    return `${year}-${month}-${day}`;
  };

  const today = new Date();
  const fifteenDaysAgo = new Date();
  fifteenDaysAgo.setDate(today.getDate() - 15);

  const start_date = String(getFormattedDate(fifteenDaysAgo)); // 15 days ago
  const end_date = String(getFormattedDate(today));

  useEffect(() => {
    let queryString = "updated_at = 15";
    let reqQueryString = `start_date=${start_date}&end_date=${end_date}`;

    dispatch(getPostRequirement(reqQueryString));
    dispatch(getTrackerDetails(queryString));
    dispatch(getSubmissionTracker(reqQueryString));
    dispatch(getProfile());
    dispatch(benchSalesProfileCardCount());
  }, [dispatch]);

  useEffect(() => {
    if (trackDetails) {
      setInternalTrack(trackDetails?.results?.data);
    }
  }, [trackDetails]);

  useEffect(() => {
    dispatch(fetchMyCredit());
  }, []);

  useEffect(() => {
    setUserDetails(profile?.data?.profile);
    setProfile_image(profile?.data?.profile?.profile_picture);
    setBanner(profile?.data?.profile?.banner_picture);

    if (profile?.data?.profile?.role === "BENCH_SALES_RECRUITER") {
      setActivityType("jobapplied");
    }
  }, [profile]);

  return (
    <Box className={styles.profile_view_structure}>
      <Box className={styles.profile_top_design}>
        <ProfileImage banner={banner} />
        <span
          style={{ display: "flex", alignItems: "center" }}
          className={styles.span_section}
        >
          <img
            src={profile_image}
            alt=""
            className={styles.banner_profile_image}
          />
          {profile?.data?.profile?.role === "BENCH_SALES_RECRUITER" ? (
            <Grid container sx={{ alignSelf: "end" }}>
              <Grid
                item
                xs={6}
                sm={6}
                md={4}
                lg={4}
                sx={{ padding: "0 0 0 10px", color: customTextColor }}
              >
                <span className={styles.profile_card}>
                  <Typography>Recent Applied</Typography>
                  <Typography sx={{ fontSize: "25px !important" }}>
                    {cardCountData?.applied_job_count}
                  </Typography>
                </span>
              </Grid>
              <Grid
                item
                xs={6}
                sm={6}
                md={4}
                lg={4}
                sx={{ padding: "0 10px 0 20px", color: customTextColor }}
              >
                <span className={styles.profile_card}>
                  <Typography>Recent Accepted</Typography>
                  <Typography sx={{ fontSize: "25px !important" }}>
                    {cardCountData?.accepted_job_count}
                  </Typography>
                </span>
              </Grid>
              <Grid
                item
                xs={6}
                sm={6}
                md={4}
                lg={4}
                sx={{ padding: "0 0 0 10px", color: customTextColor }}
              >
                <span className={styles.profile_card}>
                  <Typography>Recent Tracker Submision</Typography>
                  <Typography sx={{ fontSize: "25px !important" }}>
                    {cardCountData?.requirement_internal_tracker_count}
                  </Typography>
                </span>
              </Grid>
            </Grid>
          ) : (
            <Grid container sx={{ alignSelf: "end" }}>
              <Grid
                item
                xs={6}
                sm={6}
                md={4}
                lg={4}
                sx={{ padding: "0 10px 0 20px", color: customTextColor }}
              >
                <span className={styles.profile_card}>
                  <Typography>Recent Job Post</Typography>
                  <Typography sx={{ fontSize: "25px !important" }}>
                    {postRequirement?.jobs?.length || 0}
                  </Typography>
                </span>
              </Grid>
              <Grid
                item
                xs={6}
                sm={6}
                md={4}
                lg={4}
                sx={{ padding: "0 10px", color: customTextColor }}
              >
                <span className={styles.profile_card}>
                  <Typography>Recent Candidate Tracker</Typography>
                  <Typography sx={{ fontSize: "25px !important" }}>
                    {internalTrack?.length || 0}
                  </Typography>
                </span>
              </Grid>
              <Grid
                item
                xs={6}
                sm={6}
                md={4}
                lg={4}
                sx={{ padding: "0 0 0 10px", color: customTextColor }}
              >
                <span className={styles.profile_card}>
                  <Typography>Recent Submision Tracker</Typography>
                  <Typography sx={{ fontSize: "25px !important" }}>
                    {submisionTrackDetails?.requirements?.length || 0}
                  </Typography>
                </span>
              </Grid>
            </Grid>
          )}
        </span>
        <Box
          className={styles.profile_details}
          sx={{ display: "flex", justifyContent: "space-between" }}
        >
          <span style={{ color: customTextColor }}>
            <Typography sx={{ fontSize: "22px" }}>
              <b>{userDetails?.full_name}</b>
            </Typography>
            <Typography sx={{ color: "#767282" }}>
              {userDetails?.designation} - {userDetails?.company_name}
            </Typography>
            <Typography sx={{ color: "#767282", marginBottom: "0 !important" }}>
              Since{" "}
              {userDetails?.created_at !== undefined &&
                formatDate(userDetails?.created_at)}
              <span
                style={{ marginLeft: "5px" }}
                className={styles.view_profile_link}
                onClick={handleShowViewProfile}
              >
                (View Profile)
              </span>
            </Typography>
          </span>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: "1.2rem",
                color: "#4a4a4a",
              }}
            >
              Total Credits
            </Typography>
            <Typography
              sx={{
                color: "green",
                fontWeight: 700,
                fontSize: "1.5rem",
                // mt: 1,
                textAlign: "center",
                my: -0.3,
              }}
              variant="h3"
            >
              {myCredit?.data?.total_credits || 0}
            </Typography>
            <Typography
              sx={{
                color: "#767282",
                fontSize: "0.9rem",
                mt: 1,
                "& span": {
                  color: "#3f51b5",
                  textDecoration: "underline",
                  cursor: "pointer",
                  fontWeight: 500,
                },
                "& span:hover": {
                  color: "#1e3a8a",
                },
              }}
            >
              <span onClick={handleShowAddCredit}>View Credit</span>
              {profile?.data?.profile?.role !== "BENCH_SALES_RECRUITER" && (
                <span
                  style={{ marginLeft: "20px" }}
                  onClick={handleShowCandidateList}
                >
                  Get Leverage
                </span>
              )}
            </Typography>
          </Box>
        </Box>
      </Box>
      {profile?.data?.profile?.role !== "BENCH_SALES_RECRUITER" ? (
        <Box className={styles.activity_card_section}>
          <span className={styles.section1}>
            <Typography sx={{ color: customTextColor }}>
              Recent Activities
            </Typography>

            <TextField
              id="outlined-select-currency"
              select
              defaultValue="requirement"
              size="small"
              sx={{
                backgroundColor: "#f0f2f5",
                width: "8.5rem",
                border: "none !important",
                padding: "7px 20px 0 0",
              }}
              value={activityType}
              onChange={(e) => setActivityType(e.target.value)}
            >
              {posting_list.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          </span>

          {activityType === "requirementtracker" && (
            <>
              {loadingStatus === "loading" ? (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: 230,
                  }}
                >
                  <CircularProgress size={30} color="info" />
                </Box>
              ) : submisionTrackDetails?.requirements?.length > 0 ? (
                submisionTrackDetails?.requirements?.map((submTrack) => {
                  return (
                    <ActivityCard
                      ref1="Job Title"
                      ref2="Mode of Hiring"
                      ref3="Rate"
                      ref4="Location"
                      data1={submTrack?.job_title}
                      data2={convertArrayToString(submTrack?.requirement_type)}
                      data3={submTrack?.rate}
                      data4={submTrack?.created_at}
                      data5={getPreferLocationNames(submTrack?.location)}
                      data6="Skill Matrix"
                      data7="PM"
                      bgColor="#fff"
                      btn="View"
                      res={submTrack}
                      // route="/internal-view"
                      route="/submision-tracker"
                      storageName="internalSubmissionDetails"
                    />
                  );
                })
              ) : (
                <span
                  className={styles.recent_activity}
                  style={{ display: "block", textAlign: "center" }}
                >
                  <p style={{ marginBottom: "6px" }}>
                    {" "}
                    No Internal Requirement Found
                  </p>
                </span>
              )}
            </>
          )}

          {activityType === "jobposting" && (
            <>
              {loadingStatus === "loading" ? (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: 230,
                  }}
                >
                  <CircularProgress size={30} color="info" />
                </Box>
              ) : postRequirement?.jobs?.length > 0 ? (
                postRequirement?.jobs?.map((res) => {
                  return (
                    <ActivityCard
                      ref1="Job Title"
                      ref2="Mode of Hiring"
                      ref3="Rate"
                      ref4="Location"
                      data1={res?.job_title}
                      data2={convertArrayToString(res?.requirement_type)}
                      data3={res?.rate}
                      data4={res?.created_at}
                      data5={getPreferLocationNames(res?.location)}
                      data6="Skill Matrix"
                      data7="PM"
                      bgColor="#fff"
                      btn="View"
                      res={res}
                      route="/jobpost"
                      storageName="postJobDetails"
                    />
                  );
                })
              ) : (
                <span
                  className={styles.recent_activity}
                  style={{ display: "block", textAlign: "center" }}
                >
                  <p style={{ marginBottom: "6px" }}> No Job Posting Found</p>
                  <br />
                  <button onClick={handleShowPostRequirement}>
                    Post a Job
                  </button>
                </span>
              )}
            </>
          )}

          {activityType === "consultantstracker" && (
            <>
              {trackLoadingStatus === "loading" ? (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: 230,
                  }}
                >
                  <CircularProgress size={30} color="info" />
                </Box>
              ) : internalTrack?.length > 0 ? (
                internalTrack?.map((res) => {
                  return (
                    <ActivityCard
                      ref2="Job Profile"
                      ref1="Candidate"
                      ref3="Company"
                      ref4="Location"
                      data2={res?.current_job_title}
                      data1={res?.full_name}
                      data3={res?.current_company}
                      data4={res?.created_at}
                      data5={getLocationById(res?.current_location)}
                      data6="Skill Matrix"
                      data7="PM"
                      bgColor="#fff"
                      btn={`${res?.filled_percentage}% Setup`}
                      res={res}
                      route="/internal-tracker"
                      storageName="internalCandidateDetails"
                    />
                  );
                })
              ) : (
                <span
                  className={styles.recent_activity}
                  style={{ display: "block", textAlign: "center" }}
                >
                  <p style={{ marginBottom: "6px" }}>
                    {" "}
                    No Internal Candidate Found
                  </p>
                  <br />
                  <button
                    onClick={() => {
                      navigate("/internal-tracker-add");

                      localStorage.setItem(
                        "internalTrackerCandidateAddOrUpdate",
                        JSON.stringify({
                          row: undefined,
                          types: "add",
                        })
                      );
                    }}
                  >
                    Add Candidate
                  </button>
                </span>
              )}
            </>
          )}
        </Box>
      ) : (
        <Box className={styles.activity_card_section}>
          <span className={styles.section1}>
            <Typography sx={{ color: customTextColor }}>
              Recent Activities
            </Typography>

            <TextField
              id="outlined-select-currency"
              select
              defaultValue="requirement"
              size="small"
              sx={{
                backgroundColor: "#f0f2f5",
                width: "8.5rem",
                border: "none !important",
                padding: "7px 20px 0 0",
              }}
              value={activityType}
              onChange={(e) => setActivityType(e.target.value)}
            >
              {posting_list1.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          </span>

          {activityType === "jobapplied" && (
            <>
              {loadingStatus === "loading" ? (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: 230,
                  }}
                >
                  <CircularProgress size={30} color="info" />
                </Box>
              ) : cardCountData?.applied_jobs?.length > 0 ? (
                cardCountData?.applied_jobs?.map((submTrack) => {
                  return (
                    <ActivityCard
                      ref1="Job Title"
                      ref2="Mode of Hiring"
                      ref3="Rate"
                      ref4="Location"
                      data1={submTrack?.job_details?.job_title}
                      data2={convertArrayToString(
                        submTrack?.job_details?.requirement_type
                      )}
                      data3={submTrack?.job_details?.rate}
                      data4={submTrack?.job_details?.created_at}
                      data5={getPreferLocationNames(
                        submTrack?.job_details?.location
                      )}
                      data6="Skill Matrix"
                      data7="PM"
                      bgColor="#fff"
                      btn="View"
                      res={submTrack}
                      // route="/internal-view"
                      route="/requirement"
                      storageName="timelineJobDetails"
                    />
                  );
                })
              ) : (
                <span
                  className={styles.recent_activity}
                  style={{ display: "block", textAlign: "center" }}
                >
                  <p style={{ marginBottom: "6px" }}> No Accepted Job Found</p>
                </span>
              )}
            </>
          )}

          {activityType === "jobaccepted" && (
            <>
              {loadingStatus === "loading" ? (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: 230,
                  }}
                >
                  <CircularProgress size={30} color="info" />
                </Box>
              ) : cardCountData?.accepted_jobs?.length > 0 ? (
                cardCountData?.accepted_jobs?.map((res) => {
                  return (
                    <ActivityCard
                      ref1="Job Title"
                      ref2="Mode of Hiring"
                      ref3="Rate"
                      ref4="Location"
                      data1={res?.job_details?.job_title}
                      data2={convertArrayToString(
                        res?.job_details?.requirement_type
                      )}
                      data3={res?.job_details?.rate}
                      data4={res?.job_details?.created_at}
                      data5={getPreferLocationNames(res?.job_details?.location)}
                      data6="Skill Matrix"
                      data7="PM"
                      bgColor="#fff"
                      btn="View"
                      res={res}
                      route="/requirement"
                      storageName="timelineJobDetails"
                    />
                  );
                })
              ) : (
                <span
                  className={styles.recent_activity}
                  style={{ display: "block", textAlign: "center" }}
                >
                  <p style={{ marginBottom: "6px" }}> No Job Posting Found</p>
                </span>
              )}
            </>
          )}

          {activityType === "requirementsubmission" && (
            <>
              {trackLoadingStatus === "loading" ? (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: 230,
                  }}
                >
                  <CircularProgress size={30} color="info" />
                </Box>
              ) : cardCountData?.requirement_internal_trackers?.length > 0 ? (
                cardCountData?.requirement_internal_trackers?.map((res) => {
                  return (
                    <ActivityCard
                      ref1="Job Title"
                      ref2="Mode of Hiring"
                      ref3="Rate"
                      ref4="Location"
                      data1={res?.job_title}
                      data2={convertArrayToString(res?.requirement_type)}
                      data3={res?.rate}
                      data4={res?.created_at}
                      data5={getPreferLocationNames(res?.location)}
                      data6="Skill Matrix"
                      data7="PM"
                      bgColor="#fff"
                      btn={`View`}
                      res={res}
                      route="/submision-tracker"
                      storageName="internalSubmissionDetails"
                    />
                  );
                })
              ) : (
                <span
                  className={styles.recent_activity}
                  style={{ display: "block", textAlign: "center" }}
                >
                  <p style={{ marginBottom: "6px" }}>
                    {" "}
                    No Internal Requirement Found
                  </p>
                </span>
              )}
            </>
          )}
        </Box>
      )}
      <CandidateListDrawer
        handleShow={handleShowCandidateList}
        handleClose={handleCloseShowCandidateList}
        show={showCandidateList}
      />
      <AddCreditDrawer
        handleShow={handleShowAddCredit}
        handleClose={handleCloseShowAddCredit}
        show={showAddCredit}
        handleShowTransfor={handleShowTransfor}
      />

      <TransForCreditDrawer
        handleShow={handleShowTransfor}
        handleClose={handleCloseShowTransfor}
        show={showTransfor}
        handleShowAddCredit={handleShowAddCredit}
      />

      <ProfileViewDrawer
        handleShow={handleShowViewProfile}
        handleClose={handleCloseShowViewProfile}
        show={showViewProfile}
      />
      <RequirementPostDrawer
        handleShow={handleShowPostRequirement}
        handleClose={handleCloseShowPostRequirement}
        show={showPostRequirement}
        type="add"
      />
    </Box>
  );
};

export default Profile;
